export function startMetaTracking() {
  const pixelId = process.env.REACT_APP_META_PIXEL_ID;
  const crmOrigin = process.env.REACT_APP_META_CRM_ORIGIN;
  if (!pixelId || !/^\d+$/.test(pixelId) || !crmOrigin) return;
  try {
    if (!/^https?:$/.test(new URL(crmOrigin).protocol)) return;
  } catch { return; }

  // These scripts run only in deployments with explicit Meta configuration.
  require('./meta_tracking');
  require('./meta_tracking_bridge');
  const browser = window as any;
  if (typeof browser.fbq !== 'function') {
    const fbq: any = function (...args: any[]) {
      if (fbq.callMethod) fbq.callMethod(...args);
      else fbq.queue.push(args);
    };
    fbq.queue = [];
    fbq.push = fbq;
    fbq.loaded = true;
    fbq.version = '2.0';
    browser.fbq = fbq;
    browser._fbq = fbq;
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    document.head.appendChild(script);
    fbq('init', pixelId);
    fbq('track', 'PageView');
  }
  browser.MetaTrackingBridge.install({ crmOrigin, checkoutPaths: [
    '/api/packages-membership/training-packages/checkout',
    '/api/packages-membership/memberships/checkout',
    '/api/packages-membership/memberships/topup'
  ] });
}
